import { intoPreview } from './components/admin/products/utils'

function run() {
  document
    .querySelectorAll('img[data-item]')
    .forEach(async (img: HTMLImageElement) => {
      const data = img.getAttribute('data-item')
      if (!data) return
      const parsed = JSON.parse(data)
      const item = JSON.parse(parsed.item)
      const product = JSON.parse(parsed.product)

      const preview = await intoPreview(product, item, { skipSizeScale: true })
      preview.blend(parsed.blend)
      preview.setColor(parsed.color.id, parsed.color.usesDark)
      preview.setSize(parsed.size)
      preview.setPrintSide(parsed.side)
      const mainImage =
        `/api/media/${product.media.id}/screencap?seconds=` + parsed.frame_time
      if (parsed.side === 'back') {
        preview.backLayer?.setSource(mainImage)
      } else {
        preview.mainLayer?.setSource(mainImage)
      }

      const canvas = document.createElement('canvas')
      canvas.width = 600
      canvas.height = 600

      await preview.renderTo({ [parsed.side]: canvas })
      const url = canvas.toDataURL()
      img.src = url
      img.style.filter = 'none'
    })
}

run()
